"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _resources = _interopRequireDefault(require("./resources.graphql"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ResourceFields = function ResourceFields(_ref) {
  var _subFormikBag$errors, _subFormikBag$errors2, _selectedResource$thu;
  var isEnglish = _ref.isEnglish,
    isSpanish = _ref.isSpanish,
    renderAdvancedOptions = _ref.renderAdvancedOptions,
    subFormikBag = _ref.subFormikBag;
  var selectedResource = (subFormikBag === null || subFormikBag === void 0 ? void 0 : subFormikBag.values) || {};
  var errorResourceId = subFormikBag.submitCount > 0 && ((_subFormikBag$errors = subFormikBag.errors) === null || _subFormikBag$errors === void 0 ? void 0 : _subFormikBag$errors.resourceId);
  var errorThumbnail = subFormikBag.submitCount > 0 && ((_subFormikBag$errors2 = subFormikBag.errors) === null || _subFormikBag$errors2 === void 0 ? void 0 : _subFormikBag$errors2.thumbnail);
  function renderSvg(_ref2) {
    var value = _ref2.value;
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].svg
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: value,
      alt: "Icon"
    }));
  }
  function handleRowClick(row) {
    var needsScroll = false;
    if (!(selectedResource !== null && selectedResource !== void 0 && selectedResource.resourceId)) {
      needsScroll = true;
    }
    subFormikBag.setValues(_objectSpread(_objectSpread({}, selectedResource), {}, {
      headingEn: isEnglish ? row.label : '',
      headingEs: isSpanish ? row.label : '',
      resourceId: row.resourceId,
      thumbnail: 'default'
    }));

    // Make sure user sees the additional settings below table, when selecting resource for first time
    if (needsScroll) {
      setTimeout(function () {
        return document.getElementById('moreResourceSettings').scrollIntoView({
          behavior: 'smooth'
        });
      }, 300);
    }
  }
  function handleThumbnailChange(thumbnail) {
    subFormikBag.setFieldValue('thumbnail', thumbnail);
  }
  function handleDeleteThumbnail() {
    subFormikBag.setFieldValue('thumbnail', null);
  }
  function handleSetDefaultThumbnail() {
    subFormikBag.setFieldValue('thumbnail', 'default');
  }
  function handleSetRowClass(row) {
    if (selectedResource !== null && selectedResource !== void 0 && selectedResource.resourceId && row.resourceId === selectedResource.resourceId) {
      return 'table-primary';
    }
    return '';
  }
  var thumbnail = selectedResource === null || selectedResource === void 0 ? void 0 : selectedResource.thumbnail;
  var thumbnailUrl = selectedResource === null || selectedResource === void 0 ? void 0 : (_selectedResource$thu = selectedResource.thumbnail) === null || _selectedResource$thu === void 0 ? void 0 : _selectedResource$thu.thumbnailSmall;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_style["default"].table, " ").concat(errorResourceId ? _style["default"].tableErr : '')
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: errorResourceId ? _style["default"].labelErr : ''
  }, "Which Resource?"), /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    filter: selectedResource !== null && selectedResource !== void 0 && selectedResource.resourceId ? {
      resourceId: selectedResource.resourceId
    } : {},
    maxSelectableRows: 1,
    name: "pinnedResources",
    noRecordsMessage: "No Resources available to select",
    onRowClick: handleRowClick,
    perPage: 10,
    query: _resources["default"],
    rowKey: "resourceId",
    selectedRows: selectedResource !== null && selectedResource !== void 0 && selectedResource.resourceId ? [selectedResource.resourceId] : [],
    setRowClass: handleSetRowClass,
    striped: false,
    columns: [{
      name: 'resourceId',
      label: 'ID',
      sort: true,
      filter: true,
      width: '60px'
    }, {
      name: 'label',
      label: 'Label',
      sort: true,
      filter: true
    }, {
      name: 'resourceType',
      label: 'Type',
      sort: true,
      filter: true,
      filterSettings: {
        type: 'selectbox',
        placeholder: '-- Choose type --',
        options: [{
          label: 'Course',
          value: 'course'
        }, {
          label: 'Document',
          value: 'document'
        }, {
          label: 'Link',
          value: 'link'
        }, {
          label: 'Product',
          value: 'product'
        }, {
          label: 'Video',
          value: 'video'
        }]
      }
    }, {
      name: 'thumbnail',
      label: 'Thumbnail',
      render: renderSvg
    }, {
      name: 'updatedDate',
      label: 'Last Updated',
      sort: true,
      filter: true,
      filterSettings: {
        type: 'date'
      }
    }]
  }), errorResourceId && /*#__PURE__*/_react["default"].createElement("p", {
    className: 'text-danger ' + _style["default"].errMsg
  }, errorResourceId)), (selectedResource === null || selectedResource === void 0 ? void 0 : selectedResource.resourceId) && /*#__PURE__*/_react["default"].createElement("div", {
    id: "moreResourceSettings",
    className: _style["default"].moreSettings,
    key: selectedResource.resourceId
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-lg-6"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "headingEn"
  }, function (fieldProps) {
    return isEnglish ? /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdWysiwyg, _extends({}, fieldProps, {
      label: "Display Text (En)",
      type: "input"
    })) : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdInput, _extends({}, fieldProps, {
      disabled: true,
      label: "Display Text (En)"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-lg-6"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "headingEs"
  }, function (fieldProps) {
    return isSpanish ? /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdWysiwyg, _extends({}, fieldProps, {
      label: "Display Text (Es)",
      type: "input"
    })) : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdInput, _extends({}, fieldProps, {
      disabled: true,
      label: "Display Text (Es)"
    }));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: 'form-label ' + (errorThumbnail ? _style["default"].labelErr : '')
  }, "Thumbnail ", thumbnail === 'default' && /*#__PURE__*/_react["default"].createElement("i", null, "(using default)")), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].thumbnailPicker
  }, thumbnailUrl && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].thumbnailPreview,
    style: {
      backgroundImage: thumbnailUrl ? "url(".concat(thumbnailUrl, ")") : ''
    }
  }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.ImagePicker, {
    onChange: handleThumbnailChange,
    value: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.id,
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: 'btn btn-secondary ' + _style["default"].changeButton
    }, function () {
      if (thumbnail === 'default') {
        return 'Custom thumbnail';
      }
      if (thumbnailUrl) {
        return 'Change thumbnail';
      }
      return 'Select thumbnail';
    }())
  }), !thumbnail && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-xs btn-link",
    onClick: handleSetDefaultThumbnail
  }, "Use default thumbnail"), (thumbnailUrl || thumbnail === 'default') && /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-danger",
    onClick: handleDeleteThumbnail,
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null))), errorThumbnail && /*#__PURE__*/_react["default"].createElement("p", {
    className: 'text-danger ' + _style["default"].errMsg
  }, errorThumbnail)))), renderAdvancedOptions(subFormikBag)));
};
var _default = exports["default"] = ResourceFields;